// v4 (V4-MC): the compare routes (api/src/v4/routes-compare.ts). Under VITE_MOCK the mock installs its own source
// (src/mock/compare.ts), so the sheet and the stage work in the mock app too.
import { call } from "./api";
import type { JobView } from "./types";

export type CompareQuote = {
  step: "frame" | "clip";
  candidates: { model: string; short: string; credits: number; durationS?: number; why?: string; label: string }[];
  total: number;
  suggested: boolean;
  needsYes: boolean;
};
export type AgainQuote = { step: "frame" | "clip"; model: string; short: string; credits: number; durationS?: number };

export type CompareSource = {
  quote(projectId: string, sceneId: string, q: { step: "frame" | "clip"; models?: string[]; count?: number }): Promise<CompareQuote>;
  start(projectId: string, sceneId: string, b: { step: "frame" | "clip"; models: string[]; expectCredits: number }): Promise<{ comparisonId: string; jobs: JobView[] }>;
  use(projectId: string, sceneId: string, comparisonId: string, index: number): Promise<{ droppedClip?: boolean }>;
  againQuote(projectId: string, sceneId: string, comparisonId: string, index: number): Promise<AgainQuote>;
  again(projectId: string, sceneId: string, comparisonId: string, index: number, expectCredits: number): Promise<{ job?: JobView }>;
  makeDefault(projectId: string, sceneId: string, comparisonId: string, index: number, scope: "video" | "series"): Promise<{ where?: string }>;
};

const base = (pid: string, sid: string) => `projects/${encodeURIComponent(pid)}/shots/${encodeURIComponent(sid)}/compare`;

const http: CompareSource = {
  quote: (pid, sid, q) => call("GET", `${base(pid, sid)}/quote?step=${q.step}${q.models?.length ? `&models=${encodeURIComponent(q.models.join(","))}` : ""}${q.count ? `&count=${q.count}` : ""}`),
  start: async (pid, sid, b) => {
    const r = await call<{ comparison: { id: string }; jobs: JobView[] }>("POST", base(pid, sid), b);
    return { comparisonId: r.comparison.id, jobs: r.jobs };
  },
  use: (pid, sid, cid, index) => call("POST", `${base(pid, sid)}/${cid}/use`, { index }),
  againQuote: (pid, sid, cid, index) => call("GET", `${base(pid, sid)}/${cid}/again/quote?index=${index}`),
  again: (pid, sid, cid, index, expectCredits) => call("POST", `${base(pid, sid)}/${cid}/again`, { index, expectCredits }),
  makeDefault: (pid, sid, cid, index, scope) => call("POST", `${base(pid, sid)}/${cid}/default`, { index, scope }),
};

let source: CompareSource = http;
export function installCompareSource(s: CompareSource) {
  source = s;
}
export const compareApi: CompareSource = {
  quote: (...a) => source.quote(...a),
  start: (...a) => source.start(...a),
  use: (...a) => source.use(...a),
  againQuote: (...a) => source.againQuote(...a),
  again: (...a) => source.again(...a),
  makeDefault: (...a) => source.makeDefault(...a),
};
